// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2pO3G","productName":"Table_productName__2Otyj"};